import { render } from "./MetricsPage.vue?vue&type=template&id=7e191fc8&scoped=true"
import script from "./MetricsPage.vue?vue&type=script&lang=js"
export * from "./MetricsPage.vue?vue&type=script&lang=js"

import "./MetricsPage.vue?vue&type=style&index=0&id=7e191fc8&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e191fc8"]])

export default __exports__